export const TestIds = {
  buttonElement: 'buttonElement',
} as const;

export enum ElementType {
  Link = 'Link',
  Button = 'Button',
}
